import axios from '../utils/axios';

export default function fetchUserTagsCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/user-tags-count', { params })
    )
}
